import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type UpdateVehicleCargoItemMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateVehicleCargoItemInput;
}>;

export type UpdateVehicleCargoItemMutationResult = { __typename?: 'Mutation' } & {
  cargoUpdateVehicleCargoItem?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateVehicleCargoItemPayload' } & {
      cargoItem?: GraphQLTypes.Maybe<
        | ({ __typename?: 'CargoContainerType' } & Pick<
            GraphQLTypes.CargoContainerType,
            'cbm' | 'hazardous' | 'id' | 'looseCargoType' | 'quantity' | 'reefer' | 'type'
          > & {
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
        | ({ __typename?: 'CargoLooseCargoType' } & Pick<
            GraphQLTypes.CargoLooseCargoType,
            'cbm' | 'hazardous' | 'id' | 'looseCargoType' | 'quantity' | 'reefer' | 'type'
          > & {
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
        | ({ __typename?: 'CargoVehicleType' } & Pick<
            GraphQLTypes.CargoVehicleType,
            | 'healthCertificate'
            | 'palletType'
            | 'riskLevel'
            | 'tailLift'
            | 'trailerId'
            | 'vehicleType'
            | 'cbm'
            | 'hazardous'
            | 'id'
            | 'looseCargoType'
            | 'quantity'
            | 'reefer'
            | 'type'
          > & {
              dimensions?: GraphQLTypes.Maybe<
                { __typename?: 'CargoDimensionsType' } & Pick<
                  GraphQLTypes.CargoDimensionsType,
                  'height' | 'length' | 'metric' | 'width'
                >
              >;
              valueOfGoods?: GraphQLTypes.Maybe<{ __typename?: 'Money' } & Pick<GraphQLTypes.Money, 'currency' | 'value'>>;
              grossWeight?: GraphQLTypes.Maybe<
                { __typename?: 'CargoWeightType' } & Pick<GraphQLTypes.CargoWeightType, 'metric' | 'value'>
              >;
            })
      >;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateVehicleCargoItemDocument = gql`
  mutation updateVehicleCargoItem($input: UpdateVehicleCargoItemInput!) {
    cargoUpdateVehicleCargoItem(input: $input) {
      cargoItem {
        cbm
        grossWeight {
          metric
          value
        }
        hazardous
        id
        looseCargoType
        quantity
        reefer
        type
        ... on CargoVehicleType {
          dimensions {
            height
            length
            metric
            width
          }
          healthCertificate
          palletType
          riskLevel
          tailLift
          trailerId
          valueOfGoods {
            currency
            value
          }
          vehicleType
        }
      }
      errors {
        message
        path
      }
    }
  }
`;
